import { useState, useCallback } from 'react';
import { useAnalytics } from 'use-analytics';

const useClipboard = (timeout = 2000) => {
  const [isCopied, setIsCopied] = useState(false);
  const { track } = useAnalytics();

  const handleCopy = useCallback(
    async (textToCopy) => {
      if (!navigator.clipboard) {
        track('Сlipboard API not available', { textToCopy });
        return;
      }

      try {
        await navigator.clipboard.writeText(textToCopy);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), timeout);
      } catch (err) {
        track('Failed to copy text', { textToCopy });
      }
    },
    [timeout, track],
  );

  return [isCopied, handleCopy];
};

export default useClipboard;
